export const siteInfo = {
  name: '蘑菇视频网页版',
  slogan: '无需下载，即刻观看',
  description: '蘑菇视频网页版是一个完全基于浏览器的在线视频平台，用户无需下载任何App即可直接观看海量视频内容。支持电脑和手机端浏览器访问，提供电视剧、电影、综艺、动漫、纪录片等多种类型的视频资源。',
  founded: '2019年',
  stats: {
    videos: '20万+',
    users: '5000万+',
    dailyActive: '300万+',
    categories: '8大类',
  },
  contact: {
    email: 'support@moguvideo.com',
    wechat: '蘑菇视频官方',
    weibo: '@蘑菇视频网页版',
    workingHours: '周一至周日 9:00 - 22:00',
  },
};